module.exports = "../study/imgs/maps/Tokyo/S8/Climate/Precipitation/Tokyo_Precipitation_MIROC5_RCP85_End.png";